
const routes = [
    {
      path: "/login/:id?/:type?/:test?",
      name:"login",
      component: ()=>process.env.NODE_ENV === "development"?import("@/views/loginByAccount.vue"):import("@/views/login.vue"),
      // component: ()=>import("@/views/login.vue"),
    },
    {
      path: "/loginSuccess",
      name:"loginSuccess",
      component: ()=>import("@/views/loginSuccess.vue"),
    },
    {
      path: "/disablePrompt",
      name:"disablePrompt",
      component: ()=>import("@/views/disablePrompt.vue"),
    },
    { 
      path: "/",
      name:"layout",
      component: ()=>import("@/views/layout.vue"),
      redirect:'/activity',
      children:[
        //问卷
        {
          path: "/examine/:id?",
          name: "examine",
          component: () => import("@/views/module/examine.vue"),
        },
        //活动
        {
          path: "/activity/:id?",
          name:"activity",
          component: ()=>import("@/views/module/activity.vue"),
        },
        //活动状态
        {
          path: "/activeState/:id?",
          name:"activeState",
          component: ()=>import("@/views/module/components/activeState.vue"),
        },
        //问答
        {
          path: "/question/:id?",
          name:"question",
          component: ()=>import("@/views/module/question.vue"),
        },
        //投票
        {
          path: "/vote/:id?",
          name:"vote",
          component: ()=>import("@/views/module/vote.vue"),
        },
        //抽奖
        {
          path: "/raffle/:id?",
          name:"raffle",
          component: ()=>import("@/views/module/raffle.vue"),
        },
        //我的奖品页面
        {
          path: "/myPrize/:id?",
          name:"myPrize",
          component: ()=>import("@/views/module/myPrize.vue"),
        },
        //中奖列表
        {
          path: "/rankingList/:id?",
          name:"rankingList",
          component: ()=>import("@/views/module/rankingList.vue"),
        },
        //广告调查H5页面
        {
          path: "/advertisingCompetition/:id?",
          name: "advertisingCompetition",
          component: () => import("@/views/customizedH5/advertisingCompetitionH5/index.vue"),
        },
        // 互动部门Ｈ５
        {
          path: "/interactiveH5/:id?",
          name: "interactiveH5",
          component: () => import("@/views/customizedH5/InteractiveH5/index.vue"),
        },
        // <****广场舞蹈大赛报名****>
        //首页
        {
          path: "/danceCompetition/:id?",
          name: "danceCompHome",
          component: () => import("@/views/customizedH5/danceCompetition/home.vue"),
        },
        //报名页面
        {
          path: "/danceCompActivity/:id?",
          name: "danceCompActivity",
          component: () => import("@/views/customizedH5/danceCompetition/activity.vue"),
        },
        // 结果显示页面
        {
          path: "/danceCompResultPage/:id?/:time?",
          name: "danceCompResultPage",
          component: () => import("@/views/customizedH5/danceCompetition/resultPage.vue"),
        },
        // <****广场舞蹈大赛投票****>
        {
          path: "/danceVote/:id?",
          name: "danceVote",
          component: () => import("@/views/customizedH5/danceVote/vote.vue"),
        },
        // 东莞市 “千百万·NEWBOX”集装箱创意设计大赛
        {
          path: "/containerVoting/:id?",
          name:"containerVoting",
          meta: {
            title: "东莞市 “千百万·NEWBOX”集装箱创意设计大赛"
          },
          component: ()=>import("@/views/customizedH5/containerVoting/vote.vue"),
        },
        //消防问答
        {
          path: "/xiaoFangQuestion/:id?",
          name:"xiaoFangQuestion",
          meta: {
            title: "全民消防、生命至上-安全用火用电"
          },
          component: ()=>import("@/views/customizedH5/xiaoFangQuestion/question.vue"),
        },
        // 新春问答
        {
          path: "/springFestivalQA/:id?",
          name:"SpringFestivalQA",
          meta: {
            title: "新春大礼包"
          },
          component: ()=>import("@/views/customizedH5/springFestivalQA/index.vue"),
        },
        //曝光线索
        {
          path: "/exposure/:id?",
          name:"exposure",
          component: ()=>import("@/views/customizedH5/exposure/activity.vue"),
        },
        //安全生产月答题活动
        {
          path: "/safetyMonth/:id",
          name:"SafetyMonth",
          meta: {
            title: '安全生产月答题活动'
          },
          component: ()=>import("@/views/customizedH5/safetyMonth/question.vue"),
        },
      ]
    },
    /** 学习强国2026问答竞赛H5 */
    //1.首页
    {
      path: "/shuiWuiJuCompetition/home",
      name:"SWJCompetition",
      meta: {
        title: "双源润莞 节水同行——2026年世界水日线上“水知识”挑战赛"
      },
      component: ()=>import("@/views/customizedH5/shuiWuiJuCompetition/home.vue"),
    },
    //2.每日答题
    {
      path: "/shuiWuiJuCompetition/dailyQuizzes",
      name:"SWJDailyQuizzes",
      meta: {
        title: "每日答题"
      },
      component: ()=>import("@/views/customizedH5/shuiWuiJuCompetition/dailyQuizzes.vue"),
    },
    //答题结果
    {
      path: "/shuiWuiJuCompetition/resultPage",
      name:"SWJCompetitionResultPage",
      meta: {
        title: "答题结果"
      },
      component: ()=>import("@/views/customizedH5/shuiWuiJuCompetition/resultPage.vue"),
    },
    /** 学习强国2025问答竞赛H5 */
    //1.首页
    {
      path: "/knowledgeCompetitionH5/home",
      name:"newCompetition",
      meta: {
        title: "“全民学习 声动未来” 答题诵读活动"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionH5/home.vue"),
    },
    //2.每日答题
    {
      path: "/knowledgeCompetitionH5/dailyQuizzes",
      name:"newDailyQuizzes",
      meta: {
        title: "每日答题"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionH5/dailyQuizzes.vue"),
    },
    //3.经典朗诵
    {
      path: "/knowledgeCompetitionH5/recitationRecording",
      name:"newRecitationRecording",
      meta: {
        title: "经典朗诵"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionH5/recitationRecording.vue"),
    },
    //答题结果
    {
      path: "/knowledgeCompetitionH5/resultPage",
      name:"newCompetitionResultPage",
      meta: {
        title: "答题结果"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionH5/resultPage.vue"),
    },
    /** 学习强国问答竞赛2024年版本H5 */
    //1.首页
    {
      path: "/knowledgeCompetitionVersion1H5/home",
      name:"competition",
      meta: {
        title: "“理响东莞”线上知识竞赛"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/home.vue"),
    },
    //2.每日答题
    {
      path: "/knowledgeCompetitionVersion1H5/dailyQuizzes",
      name:"dailyQuizzes",
      meta: {
        title: "每日答题"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/dailyQuizzes.vue"),
    },
    //3.月度竞赛
    {
      path: "/knowledgeCompetitionVersion1H5/monthCompetition",
      name:"monthCompetition",
      meta: {
        title: "专题学习"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/monthCompetition.vue"),
    },
    //4.学习排名
    {
      path: "/knowledgeCompetitionVersion1H5/learningRanking",
      name:"learningRanking",
      meta: {
        title: "学习榜单"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/learningRanking.vue"),
    },
    //5.活动签到
    {
      path: "/knowledgeCompetitionVersion1H5/signIn",
      name:"signIn",
      meta: {
        title: "签到"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/signIn.vue"),
    },
    //答题结果
    {
      path: "/knowledgeCompetitionVersion1H5/resultPage",
      name:"competitionResultPage",
      meta: {
        title: "答题结果"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/resultPage.vue"),
    },
    //我的信息
    {
      path: "/knowledgeCompetitionVersion1H5/myInfo",
      name:"competitionMyInfo",
      meta: {
        title: "我的成绩单"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/myInfo.vue"),
    },
    //知识竞赛奖品列表页面
    {
      path: "/knowledgeCompetitionVersion1H5/myPrize",
      name:"competitionMyPrize",
      meta: {
        title: "我的奖品"
      },
      component: ()=>import("@/views/customizedH5/knowledgeCompetitionVersion1H5/myPrize.vue"),
    },
    /** 就业问卷H5 */
    //首页
    {
      path: "/employmentSurveyH5/home/:id?",
      name:"employmentSurveyHome",
      meta: {
        title: "首页"
      },
      component: ()=>import("@/views/customizedH5/employmentSurveyH5/home.vue"),
    },
    //调研介绍
    {
      path: "/employmentSurveyH5/introduction/:id?",
      name:"introduction",
      meta: {
        title: "调研介绍"
      },
      component: ()=>import("@/views/customizedH5/employmentSurveyH5/introduction.vue"),
    },
    //题库
    {
      path: "/employmentSurveyH5/questionBank/:id?",
      name:"questionBank",
      meta: {
        title: "调研题库"
      },
      component: ()=>import("@/views/customizedH5/employmentSurveyH5/questionBank.vue"),
    },
    //结果
    {
      path: "/employmentSurveyH5/resultPage/:resultId?/:id?",
      name:"resultPage",
      meta: {
        title: "测试结果"
      },
      component: ()=>import("@/views/customizedH5/employmentSurveyH5/resultPage.vue"),
    },
    /** 两会长图H5 */
    {
      path: "/conferenceEventDisplay/index",
      name:"conferenceEventDisplay",
      meta: {
        title: "沉浸式解锁2025东莞政府工作报告"
      },
      component: ()=>import("@/views/customizedH5/conferenceEventDisplay/index.vue"),
    },
    // 百千方益起来活动首页
    {
      path: "/spreadCreativity/home",
      name:"spreadCreativityHome",
      meta: {
        title: '"百千万·益起来"视频征集活动'
      },
      component: ()=>import("@/views/customizedH5/spreadCreativity/home.vue"),
    },
    {
      path: "/spreadCreativity/entryInformation",
      name:"entryInformation",
      meta: {
        title: '参赛须知'
      },
      component: ()=>import("@/views/customizedH5/spreadCreativity/entryInformation.vue"),
    },
    {
      path: "/spreadCreativity/submitFormData/:type?",
      name:"submitFormData",
      component: ()=>import("@/views/customizedH5/spreadCreativity/submitFormData.vue"),
    },
    {
      path: "/spreadCreativity/messagePage/:type?",
      name:"messagePage",
      meta: {
        title: '提交完成'
      },
      component: ()=>import("@/views/customizedH5/spreadCreativity/messagePage.vue"),
    },
    {
      path: "/spreadCreativity/upload",
      name:"spreadCreativityUpload",
      meta: {
        title: '文件上传'
      },
      component: ()=>import("@/views/customizedH5/spreadCreativity/upload.vue"),
    },
    {
      path: "/spreadCreativity/test",
      name:"spreadCreativityTest",
      meta: {
        title: '文件上传'
      },
      component: ()=>import("@/views/customizedH5/spreadCreativity/test.vue"),
    },
    //东莞市美丽庭院 亲子研学地图H5 - 首页
    {
      path: "/routeMapActivity/home",
      name:"RouteMapActivityHome",
      meta: {
        title: '首页'
      },
      component: ()=>import("@/views/customizedH5/routeMapActivity/index.vue"),
    },
    //东莞市美丽庭院 亲子研学地图H5 - 搜索
    {
      path: "/routeMapActivity/search",
      name:"RouteMapActivitySearch",
      meta: {
        title: '搜索'
      },
      component: ()=>import("@/views/customizedH5/routeMapActivity/search.vue"),
    },
    //东莞市美丽庭院 亲子研学地图H5 - 详情
    {
      path: "/routeMapActivity/details/:id/:type",
      name:"RouteMapActivityDetails",
      meta: {
        title: '详情'
      },
      component: ()=>import("@/views/customizedH5/routeMapActivity/details.vue"),
    },
    //2026年东莞城市慈善徒步活动
    {
      path: "/hikingSignInByCode",
      name:"HikingSignInByCode",
      meta: {
        title: '2026年东莞城市慈善徒步活动'
      },
      component: ()=>import("@/views/customizedH5/signInByCode/index.vue"),
    },
  ]

export default routes